<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    label,
    value,
    detail,
    tone = 'neutral',
    hero = false,
    children,
  }: {
    label: string;
    value: string;
    detail?: string;
    tone?: 'neutral' | 'positive' | 'negative';
    hero?: boolean;
    children?: Snippet;
  } = $props();
</script>

<section class:hero class="kpi card" aria-label={label}>
  <p class="eyebrow">{label}</p>
  <p class="kpi-value {tone}">{value}</p>
  {#if detail}<p class="muted">{detail}</p>{/if}
  {#if children}{@render children()}{/if}
</section>
